import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Question } from '../core/types';

interface Props {
  questions: Question[];
}

const truthLabel = (score: number, lang: string): { label: string; cls: string } => {
  const isEn = lang === 'en';
  if (score >= 75) return { label: isEn ? 'Credible' : '可信', cls: 'truth-high' };
  if (score >= 45) return { label: isEn ? 'Doubtful' : '存疑', cls: 'truth-medium' };
  return { label: isEn ? 'Suspicious' : '可疑', cls: 'truth-low' };
};

const QuestionPanel: React.FC<Props> = ({ questions }) => {
  const { t, i18n } = useTranslation();
  const [revealed, setRevealed] = useState<Set<string>>(new Set());

  if (questions.length === 0) return null;

  const toggle = (id: string) => {
    setRevealed(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  return (
    <div className="question-panel">
      <h2>{t('questions.title')}</h2>
      <p className="question-hint">{t('questions.hint')}</p>
      <div className="question-list">
        {questions.map(q => {
          const isOpen = revealed.has(q.id);
          const { label, cls } = truthLabel(q.truthfulness, i18n.language);
          return (
            <div key={q.id} className={`question-item ${isOpen ? 'open' : ''}`}>
              <button className="question-btn" onClick={() => toggle(q.id)}>
                <span className="question-text">{q.text}</span>
                <span className="question-arrow">{isOpen ? '▲' : '▼'}</span>
              </button>
              {isOpen && (
                <div className="question-answer">
                  <p>{q.answer}</p>
                  <div className={`truth-badge ${cls}`}>
                    {t('questions.truthfulness')}：{label}（{q.truthfulness}%）
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuestionPanel;
